module.exports = __webpack_public_path__ + "img/3.48c92f76.jpg";